// Unico lugar do app que monta titulo/subtitulo de um canal (R12 do plano
// de redesign 2026-09-22). "Catalogo do Atacado" e o NOME DO CANAL
// (catalog.channels.name, slug "atacado"), nao uma string do produto —
// nenhuma tela pode hard-codar "Atacado". O dono atualiza o nome no banco;
// esta funcao so deriva o que a API ja manda.
import type { ChannelSummary } from "./types";

/** Titulo de tela/menu para um canal: sempre channel.name, vindo da API. */
export function channelTitle(channel: Pick<ChannelSummary, "name">): string {
  return channel.name;
}

/**
 * Subtitulo curto (slug + tipo), usado em cartoes e listas de canal.
 * Nao existe campo de "nome curto" na API — truncar o nome no mobile e
 * suficiente (KISS, plano secao 0.3) em vez de criar migration so pra isso.
 */
export function channelSubtitle(channel: Pick<ChannelSummary, "slug" | "kind">): string {
  return `${channel.slug} · ${channel.kind}`;
}
